import { worshipTimes } from "../main/data/worship-times";
import { countdownService } from "./countdownService";
import { refreshService } from "./refreshService";
import { refreshDefault } from "./refreshDefault";
import { getCurrentDate, initCurrentDate } from "../cpcoc/currentDate";
import { querySelectorURLBase } from "../cpcoc/querySelectorURL";
import { getNextRefresh } from "../../utilities/nextRefresh";
import { getActiveService } from "../../utilities/activeService";
export function initTimers(url) {
    if (!url) {
        return;
    }
    initCurrentDate(querySelectorURLBase("mockDate", url));
    const countdownStatus = querySelectorURLBase("countdown", url) !== "false";
    const refreshStatus = !!querySelectorURLBase("refresh", url);
    const now = getCurrentDate();
    refreshDefault(refreshStatus, now); // default 3:00 AM/PM 12 hour interval refresh
    for (let i = 0, l = worshipTimes.length; i < l; i++) {
        const service = worshipTimes[i];
        countdownService(service, countdownStatus);
        refreshService(service, refreshStatus, now);
    }
    const msgData = {
        type: 3 /* TimerMessageTypes.Initial */,
        nextRefresh: getNextRefresh(),
        activeService: getActiveService(),
    };
    self.postMessage(msgData);
}
